import React from 'react';
import { ProductData, RetailerData, ModalContext } from '../types';
import { WizardView } from './WizardView';

interface FitSessionViewProps {
  productData: ProductData;
  retailerData: RetailerData;
  apiUrl: string;
  context?: ModalContext;
  brandingHideLogo?: boolean;
}

export const FitSessionView: React.FC<FitSessionViewProps> = ({
  productData,
  retailerData,
  apiUrl,
  context,
  brandingHideLogo
}) => {
  return (
    <div className="modal-content modal-content--full">
      <WizardView 
        productData={productData} 
        retailerData={retailerData} 
        apiUrl={apiUrl} 
        context={context}
        brandingHideLogo={brandingHideLogo}
      />
    </div>
  );
};
